/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { useEffect, useState } from "react";

import { CountryBrandApplicationAttachments } from "../../../../domain/CountryBrandApplication";
import {
	ICountryBrandApplicationContext,
	useCountryBrandApplicationContext,
} from "../../contexts/CountryBrandApplicationContextProvider";
import { UIEvents } from "../../UIEvents";

function AttachDocumentation() {
	const { currentStep, countryBrandApplication, update, setPreviousStep } =
		useCountryBrandApplicationContext() as ICountryBrandApplicationContext;

	const [attachments, setAttachments] = useState<CountryBrandApplicationAttachments[]>(
		countryBrandApplication.attachments
	);

	const dgiAttachment = attachments.find((e) => e.type === "DGI" && e.status !== "DELETE");
	const bpsAttachment = attachments.find((e) => e.type === "BPS" && e.status !== "DELETE");

	useEffect(() => {
		setPreviousStep(currentStep - 1);
		function submitStepData() {
			update({
				data: {
					attachments,
				},
				nextStep: currentStep + 1,
			});
		}
		document.addEventListener(UIEvents.builtInFormValidateSucess, submitStepData);

		return () => {
			document.removeEventListener(UIEvents.builtInFormValidateSucess, submitStepData);
		};
	}, [attachments]);

	async function handleFileChange(e: React.ChangeEvent<HTMLInputElement>) {
		const file = e.target.files[0];
		if (file) {
			const type = e.target.name;
			const id = file.name + type;
			setAttachments([
				...attachments
					.filter((att) => !((att.type === type || att.group === type)  && att.status === "ADD"))
					.map((att) => (att.type === type || att.group === type ? { ...att, status: "DELETE" } : { ...att })),
				{
					id,
					name: file.name,
					url: "",
					type,
					status: "ADD",
					file,
				},
			]);
		}
		e.target.value = null;
	}

	function handleClickDeleteRow(attachment: CountryBrandApplicationAttachments) {
		if (attachment.status === "ADD") {
			setAttachments(attachments.filter((e) => e.id !== attachment.id));
		} else {
			setAttachments(
				attachments.map((e) => (e.id === attachment.id ? { ...e, status: "DELETE" } : { ...e }))
			);
		}
	}

	return (
		<div className="step-page" id="step-6">
			<section>
				<h3>6 - Adjuntar documentación legal de la empresa</h3>
				<article className="attachment-article">
					<label htmlFor="DGI">
						{"Certificado DGI "}
						<a
							className="button btn-small"
							href="https://servicios.dgi.gub.uy/ServiciosEnLinea/dgi--servicios-en-linea--consulta-de-certifcado-unico?es"
							target="_blank"
							rel="noreferrer"
						>
							{"(Descargar certificado)"}
						</a>
					</label>
					<input
						className="input-file"
						id="dgi"
						type="file"
						name="DGI"
						onChange={handleFileChange}
					/>
					{dgiAttachment && (
						<ul className="attachments-list">
							<li className="attachment-item">
								{dgiAttachment.status !== "ADD" && dgiAttachment.status !== "DELETE" ? (
									<a
										className="button btn-small"
										download={true}
										href={dgiAttachment.url}
										target="_blank"
										rel="noreferrer"
									>
										{dgiAttachment.name}
									</a>
								) : dgiAttachment.status === "ADD" ? (
									<span>{dgiAttachment.name}</span>
								) : ""}

								<button
									className="btn-small"
									type="button"
									onClick={() => handleClickDeleteRow(dgiAttachment)}
								>
									Borrar
								</button>
							</li>
						</ul>
					)}
				</article>
				<article className="attachment-article">
					<label htmlFor="BPS">
						{"Certificado BPS "}
						<a
							className="button btn-small"
							href="https://scp.bps.gub.uy/my.policy"
							target="_blank"
							rel="noreferrer"
						>
							{"(Descargar certificado)"}
						</a>
					</label>
					<input className="input-file" type="file" name="BPS" onChange={handleFileChange} />
					{bpsAttachment && (
						<ul className="attachments-list">
							<li className="attachment-item">
								{bpsAttachment.status !== "ADD" && bpsAttachment.status !== "DELETE" ? (
									<a
										className="button btn-small"
										download={true}
										href={bpsAttachment.url}
										target="_blank"
										rel="noreferrer"
									>
										{bpsAttachment.name}
									</a>
								) : bpsAttachment.status === "ADD" ? (
									<span>{bpsAttachment.name}</span>
								) : ""}
								<button
									className="btn-small"
									type="button"
									onClick={() => handleClickDeleteRow(bpsAttachment)}
								>
									Borrar
								</button>
							</li>
						</ul>
					)}
				</article>
			</section>
		</div>
	);
}

export { AttachDocumentation };
